import { z } from "zod";

const reasonSchema = z.object(
  {
    id: z.string(),
    code: z.string(),
  },
  {
    required_error: "components.schedule.schedulePopover.reason.error",
    invalid_type_error: "components.schedule.schedulePopover.reason.error",
  }
);

export const cancelSchema = z.object({
  reason: reasonSchema,
  justification: z.string({
    required_error: "components.schedule.schedulePopover.justification.error",
    invalid_type_error: "components.schedule.schedulePopover.justification.error",
  }).min(1,'components.schedule.schedulePopover.justification.error'),
});

export type TCancel = z.infer<typeof cancelSchema>;
